import { render, staticRenderFns } from "./text-block-values.vue?vue&type=template&id=2178ebe0&scoped=true"
import script from "./text-block-values.vue?vue&type=script&lang=js"
export * from "./text-block-values.vue?vue&type=script&lang=js"
import style0 from "./text-block-values.vue?vue&type=style&index=0&id=2178ebe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178ebe0",
  null
  
)

export default component.exports